import React, { useContext } from "react";

// mui
import { styled } from "@mui/material/styles";
// component
import Grid from "@mui/material/Grid";
import TopPanel from "./topPanel/TopPanel";
import BottomPanel from "./bottomPanel/BottomPanel";
import { StoreContext } from "../../../../../../store/StoreProvider";
import StyledMain from "../component/StyledMain";

const OcrPage = () => {
  const [state, _] = useContext(StoreContext);
  const { sna } = state;
  const { open } = sna.sidebar;

  return (
    <StyledMain open={open}>
      <Grid className="DigitalAITool__AI" px={3} py={2}>
        <Grid>
          <TopPanel />
        </Grid>
        <Grid>
          <BottomPanel />
        </Grid>
      </Grid>
    </StyledMain>
  );
};
export default OcrPage;
